import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
import EvidenceUpload from '@/modules/EvidenceUpload/EvidenceInfo.vue';
import apis from '@/apis/caseManage';
import BreadcrumbHeader from '../Layout/BreadcrumbHeader.vue';
import TrialInfo from './TrialInfo.vue';
import BaseInfo from './BaseInfo.vue';

var CaseInfo = /*#__PURE__*/function (_Vue) {
  _inherits(CaseInfo, _Vue);

  var _super = _createSuper(CaseInfo);

  function CaseInfo() {
    var _this;

    _classCallCheck(this, CaseInfo);

    _this = _super.apply(this, arguments);
    _this.activeTab = 'baseInfo';
    _this.baseInfo = {
      caseName: '',
      caseNoAll: '',
      caseTypeName: '',
      trialProgramName: '',
      caseReasonName: '',
      registerTime: '',
      undertakerDeptName: '',
      undertakerPersonName: '',
      caseResume: '',
      status: '',
      partyList: [],
      procuratorList: []
    };
    _this.trialInfo = {
      caseId: '',
      caseIndexCode: '',
      caseNo: '',
      recordDetailList: [],
      scheduleInfo: {}
    };
    _this.nearestSchedule = {
      trialStatus: '',
      tribunalName: '',
      planStartTime: '',
      planDate: ''
    };
    return _this;
  }

  _createClass(CaseInfo, [{
    key: "mounted",
    value: function mounted() {
      this.getBaseInfo();
      this.getTrialInfo();
      this.getNearestSchedule();
    } // 获取基本信息

  }, {
    key: "getBaseInfo",
    value: function getBaseInfo() {
      var _this2 = this;

      apis.caseDetail({
        caseIndexCode: this.id
      }).then(function (res) {
        var data = res.data; // 将 partyUuid 处理为 代理对象详情列表

        data.procuratorList.forEach(function (procurator) {
          procurator.dldx = [];

          if (procurator.partyUuid) {
            procurator.partyUuid.split(',').forEach(function (uuid) {
              var party = data.partyList.find(function (item) {
                return item.uuid === uuid;
              });

              if (party) {
                procurator.dldx.push(party);
              }
            });
          }
        });
        _this2.baseInfo = data;
      });
    } // 获取庭审信息

  }, {
    key: "getTrialInfo",
    value: function getTrialInfo() {
      var _this3 = this;

      apis.trialRecords({
        caseId: this.id
      }).then(function (res) {
        _this3.trialInfo = res.data;
      });
    } // 获取最近一次排期

  }, {
    key: "getNearestSchedule",
    value: function getNearestSchedule() {
      var _this4 = this;

      apis.nearestSchedule({
        caseIndexCode: this.id
      }).then(function (res) {
        _this4.nearestSchedule = res.data;
      });
    }
  }, {
    key: "handleBackToTrial",
    value: function handleBackToTrial() {
      var _this5 = this;

      this.$confirm('退回重审后需要重新排期，确定退回吗?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'question',
        onConfirm: function () {
          var _onConfirm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    apis.changeTrialStatus({
                      caseId: _this5.id
                    }).then(function () {
                      _this5.$message({
                        type: 'success',
                        message: '退回重审成功!'
                      });

                      _this5.getBaseInfo();

                      _this5.getTrialInfo();
                    }).catch(function (_) {});

                  case 1:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          function onConfirm() {
            return _onConfirm.apply(this, arguments);
          }

          return onConfirm;
        }(),
        onCancel: function onCancel() {}
      });
    }
  }]);

  return CaseInfo;
}(Vue);

__decorate([Prop({
  required: true
})], CaseInfo.prototype, "id", void 0);

CaseInfo = __decorate([Component({
  components: {
    BreadcrumbHeader: BreadcrumbHeader,
    TrialInfo: TrialInfo,
    BaseInfo: BaseInfo,
    EvidenceUpload: EvidenceUpload
  }
})], CaseInfo);
export default CaseInfo;